//code
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import logoSenior from '../../../assets/logo.png';
import { WizardTitle } from '../../wizard/components/WizardTitle';
import { useWizardRequest } from '../../../hooks/services/useWizardRequest';
import WizardButton from '../../wizard/components/WizardButton';
import { ShowError, StyledAlert } from '../../wizard/components/ErrorMessage';
import IPage from '../../../interfaces/IPage';
import WizardTextField from '../../wizard/components/WizardTextField';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Img, WizardFooter, Link, Container, WizardContent } from './ConsultProtocolDocument.styled';
import InstallPWA from '../../../components/InstallPWA/InstallPWA';
import { useTenantDomainService } from '../../../hooks/services/useTenantDomainService';
import { useValidateSchema } from '../../../hooks/providers/useValidateSchema';
import ILocalSettings from '../../../interfaces/ILocalSettings';
import { useLocalStorage } from '../../../hooks/providers/useLocalStorage';
import IFormError from '../../../interfaces/IFormError';
import LoginIcon from '@mui/icons-material/Login';

interface ConsultProtocolDocumentprops extends IPage {}

const ConsultProtocolDocument = (props: ConsultProtocolDocumentprops) => {
  window.document.title = props.title;
  const [protocol, setProtocol] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [tenantDomain, setTenantDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errors, setErrors] = useState<IFormError | null>(null);
  const [localSettings, setLocalSettings] = useState<ILocalSettings>({});
  const navigate = useNavigate();
  const validation = useValidateSchema();
  const request = useWizardRequest();
  const tenantDomainService = useTenantDomainService();
  const localStorage = useLocalStorage();

  const schema = yup.object({
    tenantDomain: yup.string().required('É necessário informar o domínio.'),
  });

  const getLocalSettings = () => {
    setLocalSettings(localStorage.getItem('localSettings'));

    if (localSettings?.tenantDomain) {
      setTenantDomain(localSettings.tenantDomain);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const result = await validation.validate(schema, { tenantDomain }).then(result => {
      return result;
    });

    if (!result.isValid) {
      setErrors(result.errors);
      return;
    } else {
      setErrors(null);
    }
    setLoading(true);
    await tenantDomainService
      .getTenantDomain({ tenantDomain })
      .then(async () => {
        setLoading(false);
        setSearchParams({ tenantDomain });
        localStorage.setItem('localSettings', { tenantDomain });
        await request
          .findByProtocolNumberNotAuth(protocol)
          .then(result => {
            setLoading(false);
            navigate(`/consulta/${protocol}?tenantDomain=${tenantDomain}`);
          })
          .catch(() => {
            setLoading(false);
            setIsError(true);
          });
      })
      .catch(() => {
        setLoading(false);
        setIsError(true);
      });
  };

  useEffect(() => {
    getLocalSettings();
    setTenantDomain(searchParams.get('tenantDomain') ?? '');
    localStorage.removeItem('medicalCertificate');
  }, []);
  return (
    <Container>
      <WizardContent>
        <InstallPWA type="link" />
        <Link onClick={() => navigate('/login')}>
          <LoginIcon/>
          Login
        </Link>
        <WizardTitle>Informe número de protocolo do Documento</WizardTitle>
        <form onSubmit={handleSubmit}>
          {tenantDomain === '' ? (
            <WizardTextField
              label="Dominio"
              placeholder="exemplo: seniornortepr.com.br"
              variant="outlined"
              sx={{ width: '300px' }}
              onBlur={e => {
                setTenantDomain(e.target.value);
                setIsError(false);
              }}
              error={Boolean(errors?.tenantDomain)}
              helperText={Boolean(errors?.tenantDomain) ? errors?.tenantDomain : ''}
              //sx={{ marginBottom: '5px', width: '300px' }}
            />
          ) : null}
          <WizardTextField
            label="Protocolo"
            placeholder="Digite o Protocolo"
            variant="outlined"
            sx={{ width: '300px', marginTop: '20px' }}
            onBlur={e => {
              setProtocol(e.target.value);
            }}
          />
          <br />
          <div>
            <ShowError show={isError}>
              <StyledAlert severity="error">
                Ops, não conseguimos localizar o documento com os dados informados. Entre em contato com o RH ou tente
                novamente.
              </StyledAlert>
            </ShowError>
          </div>
          <WizardButton
            isLoading={loading}
            disabled={loading}
            sx={{ marginTop: '5px', marginBottom: '0' }}
            type="submit"
          >
            Consultar
          </WizardButton>
        </form>
      </WizardContent>
      <WizardFooter style={{ marginBottom: '0px' }}>
        <>
          <Img src={logoSenior} alt="Senior" />
          Senior Norte PR
        </>
      </WizardFooter>
    </Container>
  );
};

export default ConsultProtocolDocument;
